import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import {
  getLoginUserDetails,
  isOnboardingCompleteFromUser,
} from '../utils/onboarding.util';

@Injectable({ providedIn: 'root' })
export class OnboardingCompleteGuard {
  constructor(private router: Router) {}

  canActivate(): boolean | UrlTree {
    const user = getLoginUserDetails();
    if (!user) {
      return this.router.createUrlTree(['/auth/login']);
    }
    if (!isOnboardingCompleteFromUser(user)) {
      return this.router.createUrlTree(['/onboarding', 'welcome']);
    }
    return true;
  }
}
